<template>
    <div class="container">
        <div class="content">
            <van-field
                v-model="brandName"
                type="text"
                required
                @click="handleBrand"
                label="商品品牌"
                :readonly = 'true'
                right-icon="arrow"
                placeholder="请选择品牌"
            />
            <div class='textArea'>
                <van-field
                    v-model="form.requiredProductDescription"
                    rows="5"
                    required
                    autosize
                    label="所需商品描述"
                    type="textarea"
                    maxlength="200"
                    error-message="(简要描述型号、功能、功率或特征等信息，方便帮您寻找商品，一次可询多个商品。)"
                />
                <span v-show="!form.requiredProductDescription">示例：<br />格力多联机 <br />GMV-NH71PL/F <br />GMV-NH36PL/F</span>
            </div>
            <van-field
                v-model="form.inquiryCount"
                type="digit"
                required
                label="询价数量"
                maxlength="10"
                placeholder="未填写"
            />
            <van-field
                v-model="form.expectedPrice"
                type="digit"
                label="期望价格"
                maxlength="7"
                placeholder="面议"
            />
        </div>
        <div class="content">
            <van-field
                v-model="expectedReceiptName"
                type="text"
                required
                @click="handleDeta"
                label-class='yangs'
                label="期望到货时间"
                :readonly = 'true'
                right-icon="arrow"
                placeholder=""
            />
            <van-field
                v-model="addressName"
                type="text"
                required
                @click="onArea"
                label="安装地址"
                :readonly = 'true'
                right-icon="arrow"
                placeholder="请选择"
            />
        </div>
        <div class="content">
            <van-field
                v-model="form.contactName"
                type="text"
                required
                label="联系人"
                placeholder="未填写"
            />
            <van-field
                v-model="form.contactMobile"
                type="tel"
                required
                maxlength="11"
                label="联系电话"
                placeholder="未填写"
            />
            <van-field
                v-model="form.remark"
                rows="4"
                autosize
                label="备注"
                maxlength="200"
                type="textarea"
                placeholder="未填写"
            />
        </div>
        <div class="btn">
            <van-button type="primary" color="#FF7A45" @click="handleSubmit" :disabled='btnDis' round block>提交</van-button>
        </div>
        <BrandList :brandReault.sync="brandShow" @brandClick="brandInfo" />
        <AreaList ref="area" @onArea='onAreaData' />
        <VantPopup :data='delivery' :popupReault.sync='popupShow' @onPopup='handleDeta' />
    </div>
</template>

<script>
import BrandList from './brandList'
import AreaList from '../../common/area'
import VantPopup from './vantPopup'
import { Toast } from 'vant'
export default {
    components: {
        BrandList,
        AreaList,
        VantPopup
    },
    data () {
        return {
            brand: '',
            message: '',
            amount: '',
            userInfo: '',
            placeText: `示例：\n格力多联机 \nGMV-NH71PL/F \nGMV-NH36PL/F`,
            brandShow: false,
            popupShow: false,
            delivery: '',
            brandName: '',
            expectedReceiptName: '不限',
            addressName: '',
            expectedPrice: '',
            btnDis: false,
            form: {
                requiredProductDescription: '',
                inquiryCount: '',
                expectedPrice: '',
                expectedReceiptType: 10,
                provinceId: '',
                provinceName: '',
                cityId: '',
                cityName: '',
                areaId: '',
                areaName: '',
                contactName: '',
                contactMobile: '',
                remark: '',
                userId: ''
            }
        }
    },
    watch: {
        'form.inquiryCount': function (newVal, oldVal) {
            if (newVal.length == 1) {
                this.form.inquiryCount = newVal.replace(/[^1-9]/g, '')
            } else {
                this.form.inquiryCount = newVal.replace(/\D/g, '')
            }
        },
        'form.expectedPrice': function (newVal, oldVal) {
            if (newVal.length == 1) {
                this.form.expectedPrice = newVal.replace(/[^0-9]/g, '')
            } else {
                this.form.expectedPrice = newVal.replace(/\D/g, '')
            }
        }
    },
    methods: {
        onArea () {
            this.$refs.area.onShow()
        },
        onAreaData (data) {
            this.addressName = data.addressName
            this.form.provinceId = data.provinceId
            this.form.provinceName = data.provinceName
            this.form.cityId = data.cityId
            this.form.cityName = data.cityName
            this.form.areaId = data.countryId
            this.form.areaName = data.countryName
        },
        handleDeta (val) {
            this.popupShow = !this.popupShow
            if (val.id) {
                this.form.expectedReceiptType = val.id
                this.expectedReceiptName = val.text
            }
        },
        handleBrand () {
            this.brandShow = true
        },
        brandInfo (data) {
            this.brandName = data.name
            this.form.brandId = data.id
        },
        handleSubmit () {
            if (!this.form.brandId) {
                Toast('请选择品牌')
                return
            }
            if (!this.form.requiredProductDescription) {
                Toast('请输入所需商品描述')
                return
            }
            if (!this.form.inquiryCount) {
                Toast('请输入询价数量')
                return
            }
            if (!this.addressName) {
                Toast('请选择安装地址')
                return
            }
            if (!this.form.contactName) {
                Toast('请输入联系人')
                return
            }
            if (!this.form.contactMobile) {
                Toast('请输入联系电话')
                return
            } else if (!(/^1[3456789]\d{9}$/.test(this.form.contactMobile))) {
                Toast('手机号码不合法，请重新输入')
                return false
            }
            this.btnDis = true
            this.form.merchantCode = this.userInfo.belongMerchantCode
            this.form.memberCode = this.userInfo.companyCode
            this.form.userId = this.userInfo.id
            this.$emit('submit', this.form)
        },
        handleBtn () {
            this.btnDis = false
        }
    },
    created () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.form.contactName = this.userInfo.name
        this.form.contactMobile = this.userInfo.phone
    }
}
</script>

<style lang="scss" scoped>
    .container{
        font-size: 28px;
        .content{
            background: #ffffff;
            padding-left: 32px;
            margin-top: 20px;
        }
        .btn{
            padding: 48px 32px 80px;
            font-size: 32px;
        }
    }
    .textArea {
        position: relative;
        span{
            position: absolute;
            top: 35px;
            left: 150px;
            font-size: 28px;
            line-height: 45px;
            color: #C7C7C7;
            z-index: 0;
        }
    }
    /deep/ .van-cell{
        padding-right: 24px;
        color: #000000;
    }
    /deep/ .van-field__label{
        // width: 152px;
        height: auto;
        padding-right: 20px;
    }
    /deep/ .van-cell__value{
        height: auto;
    }
    /deep/ .yangs + .van-cell__value{
        align-self: center;
    }
    /deep/ .van-field__error-message{
        font-size: 24px;
        color: #999999;
        line-height: 34px;
    }
    /deep/ .van-button {
        height: 96px;
        line-height: 96px;
        font-size: 32px;
    }
    /deep/ .van-field__control {
        z-index: 99;
    }
</style>